import React, { FC } from 'react';
import {
  Box,
  capitalize,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SignatureType } from '../services/types';
import { convertUnixTimestamp } from '../../../utils';
import { TFunction } from 'i18next';
import { Cellstatus } from './cell-status';
import { SignatureFrom } from './signature-from';

const useStyles = makeStyles((theme: any) => ({
  description: {
    color: theme.palette.primary.darker,
    width: 'max-content',
    textTransform: 'capitalize',
    fontWeight: 'bold',
  },
  ron: {
    color: theme.palette.primary.darker,
    width: 'max-content',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    fontSize: "0.7rem"
  },
  date: {
    color: theme.palette.primary.darker,
    fontSize: 14,
    width: 'max-content',
  },
}));

type Props = {
  t: TFunction,
  signature: SignatureType,
  handleDownload: (link: string, fileName: string) => void,
};

export const SignatureRow: FC<Props> = ({
  t,
  signature,
  handleDownload
}) => {
  const classes = useStyles();
  const cells = [
    {
      id: 'name',
      content:
        (
          <Box>
            <Typography className={classes.description}>{signature.file_description}</Typography>
            {signature.embedded && (<Typography className={classes.ron}>{t('documents:ron')}</Typography>)}
          </Box>
        )
    },
    {
      id: 'date',
      content: (
        <Typography className={classes.date}>
          {capitalize(convertUnixTimestamp(signature.timestamp.toString()))}
        </Typography>
      ),
      hide: false,
    },
    {
      id: 'signature-from',
      content: (
        <SignatureFrom signature={signature} />
      ),
      hide: false,
    },
    {
      id: 'notes',
      content: (
        <Box>
          {signature.error && (
            <Typography className={classes.date}>
              {signature.error}
            </Typography>
          )}
          {signature.signers.filter(signer => signer.error)
            .map(({ name, error }) => (
              <Typography className={classes.date}>
                {`${name}: ${error}`}
              </Typography>
            ))}
        </Box>
      ),
      hide: false,
    },
    {
      id: 'status',
      content: (<Cellstatus signature={signature} />),
      hide: false,
    },
    {
      id: 'options',
      content: (
        <Box style={{ display: 'flex', gap: '0.4rem' }}>
          {signature.download != null && signature.download && (
            <IconButton
              size="small"
              onClick={() => handleDownload(signature.download, signature.file_description)}
            >
              <FontAwesomeIcon icon="download" />
            </IconButton>
          )}
        </Box>
      ),
    },
  ];

  return (
    <TableRow>
      {cells
        .filter((cell) => !cell.hide)
        .map((cell) => (
          <TableCell key={cell.id}>{cell.content}</TableCell>
        ))}
    </TableRow>
  );
};
